export default __webpack_public_path__ + "static/media/Male-3.5bd18e3d.svg";